import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CloseDialog, OpenDialog } from './report.actions';
import { patch } from '@ngxs/store/operators';

export type ReportStateModel = {
  open: boolean;
};

export const initialState: ReportStateModel = {
  open: false,
};

@State<ReportStateModel>({
  name: 'reportDialog',
  defaults: initialState,
})
@Injectable()
export class ReportDialogState {

  @Selector()
  static open(state: ReportStateModel): boolean {
    return state.open;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<ReportStateModel>) {
    context.setState(
      patch({
        open: true,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<ReportStateModel>) {
    context.setState(
      patch({
        open: false,
      }),
    );
  }
}
